import type { DrinkActivitySummary } from "../../../services/drinkService";
import { getLocalDayKey } from "../drinkHistory/dayBucketing";

export type RecapMetrics = {
    totalDrinks: number;
    drinkingDays: number;
    averagePerDrinkingDay: number;
    yearDifference: number;
    busiestMonth: number;
    mostFrequentDrink: string | null;
    monthlyCounts: { month: number; count: number }[];
};

export const getRecapYears = (activities: DrinkActivitySummary[]): number[] => {
    const years = new Set<number>();
    activities.forEach(({ timestamp }) => {
        if (timestamp && !Number.isNaN(timestamp.getTime())) years.add(timestamp.getFullYear());
    });
    return Array.from(years).sort((a, b) => b - a);
};

export const getRecapMetrics = (activities: DrinkActivitySummary[], year: number): RecapMetrics => {
    const monthlyCounts = Array.from({ length: 12 }, (_, month) => ({ month, count: 0 }));
    const drinkingDays = new Set<string>();
    const drinkCounts = new Map<string, number>();
    let totalDrinks = 0;
    let previousYearTotal = 0;

    activities.forEach(({ timestamp, drinkName }) => {
        if (!timestamp || Number.isNaN(timestamp.getTime())) return;
        if (timestamp.getFullYear() === year - 1) previousYearTotal += 1;
        if (timestamp.getFullYear() !== year) return;
        totalDrinks += 1;
        monthlyCounts[timestamp.getMonth()].count += 1;
        drinkingDays.add(getLocalDayKey(timestamp));
        drinkCounts.set(drinkName, (drinkCounts.get(drinkName) ?? 0) + 1);
    });

    let mostFrequentDrink: string | null = null;
    let mostFrequentCount = 0;
    drinkCounts.forEach((count, name) => {
        if (count > mostFrequentCount) {
            mostFrequentDrink = name;
            mostFrequentCount = count;
        }
    });
    const busiestMonth = monthlyCounts.reduce((best, item) => item.count > monthlyCounts[best].count ? item.month : best, 0);

    return {
        totalDrinks,
        drinkingDays: drinkingDays.size,
        averagePerDrinkingDay: drinkingDays.size ? totalDrinks / drinkingDays.size : 0,
        yearDifference: totalDrinks - previousYearTotal,
        busiestMonth,
        mostFrequentDrink,
        monthlyCounts,
    };
};
